import { useTranslation } from "react-i18next";

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="flex flex-col items-center text-center">
          {/* Top Image */}
          <div className="w-full max-w-[900px] rounded-3xl overflow-hidden mb-12 md:mb-16">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20inviting%20flat%20lay%20composition%20of%20lifestyle%20and%20fashion%20products%20including%20folded%20beige%20linen%20sweaters%20cream%20colored%20shoes%20and%20minimalist%20accessories%20arranged%20with%20dried%20flowers%20and%20a%20cup%20of%20coffee%20on%20a%20soft%20sand%20colored%20surface%20gentle%20natural%20sunlight%20from%20window%20creating%20cozy%20atmosphere%20editorial%20product%20photography%20with%20coral%20and%20sage%20green%20accents%20European%20aesthetic%20clean%20composition&width=1600&height=700&seq=cta-flatlay-v2-2026&orientation=landscape"
              alt="HoobuySpreadsheet - Aceda agora"
              title="Aceder ao HoobuySpreadsheet"
              className="w-full h-auto object-cover"
              loading="lazy"
            />
          </div>

          {/* Text */}
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight max-w-2xl">
            {t("cta.line1")}
            <br />
            <em className="text-foreground-400 font-light">{t("cta.line2")}</em>
            <br />
            <span className="font-bold">{t("cta.line3")}</span>
          </h2>

          {/* CTA Button */}
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center justify-center gap-2 mt-10 px-10 py-4 bg-foreground-950 text-background-50 text-sm md:text-base font-medium rounded-full hover:bg-foreground-800 transition-all duration-200 cursor-pointer whitespace-nowrap group"
          >
            <span>{t("cta.button")}</span>
            <i className="ri-arrow-right-up-line text-lg group-hover:translate-x-0.5 transition-transform"></i>
          </a>
          <p className="text-xs text-foreground-300 mt-4">{t("cta.secure")}</p>
        </div>
      </div>
    </section>
  );
}